import React from 'react';
import { MapPinIcon, StarIcon } from 'lucide-react';
import { Reveal } from './Section';
type Review = {
  initials: string;
  name: string;
  detail: string;
  quote: string;
};
const reviews: Review[] = [{
  initials: 'SM',
  name: 'Sebastián M.',
  detail: 'Buenos Aires · Joven Argentino',
  quote: 'Aprendí la estrategia en una tarde. Hice backtesting durante los 5 días recomendados y al 6º ya estaba operando con mucha más claridad.'
}, {
  initials: 'CR',
  name: 'Claudia R.',
  detail: 'Rosario · Inversor principiante',
  quote: 'Los 80 tips para arrancar en el mercado me cambiaron la forma de ver los gráficos. Ya puedo tener más claridad en mis operaciones.'
}, {
  initials: 'DP',
  name: 'Diego P.',
  detail: 'Córdoba · Inversor Mister',
  quote: 'El sistema de “Primero no perder” es único. Mis operaciones ahora se enfocan en respetar mi gestión de riesgo y no solamente ganar.'
}];
function GoldStars() {
  return <div className="mt-5 flex gap-1" aria-label="5 de 5 estrellas" data-id="element-171" data-mp="1tysbikgrlcn3">
      {Array.from({
      length: 5
    }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-amber-400 text-amber-400" data-id="element-172" data-mp="1yr3ksdxeaasb" data-mpi={index} />)}
    </div>;
}
export function SocialProofReviews() {
  return <section className="w-full bg-ink-950 px-5 py-14 sm:py-16" data-id="element-173" data-mp="1p08o0fmivssm">
      <div className="mx-auto w-full max-w-4xl" data-id="element-174" data-mp="1p0qvk8emxtfu">
        <Reveal data-id="element-175" data-mp="2cpa14g6avs48">
          <div className="text-center" data-id="element-176" data-mp="2cpjp5y7sbp7a">
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-brand" data-id="element-177" data-mp="2cnqkgogqff1x">
              Experiencias reales
            </p>
            <h2 className="mt-3 font-display text-2xl font-bold tracking-tight text-white sm:text-3xl" data-id="element-178" data-mp="22s5cm9ozfkk9">
              Claridad para empezar con método
            </h2>
          </div>
        </Reveal>

        <div className="mt-8 grid gap-4 lg:grid-cols-3" data-id="element-179" data-mp="rbywwvo9ypga">
          {reviews.map((review, index) => <Reveal key={review.initials} delay={index * 0.08} data-id="element-180" data-mp="wc341v3am7tu" data-mpi={index}>
              <figure className="flex h-full flex-col rounded-2xl border border-brand/35 bg-black p-5 sm:p-6" data-id="element-181" data-mp="w974y3fpld3t">
                <div className="flex items-center gap-3" data-id="element-182" data-mp="2tz5hxgcddb0w">
                  <span className="flex h-11 w-11 flex-none items-center justify-center rounded-full border border-brand/40 bg-brand-soft font-display text-sm font-bold text-brand" data-id="element-183" data-mp="2tznop6wnr7n2">
                    {review.initials}
                  </span>
                  <div className="min-w-0" data-id="element-184" data-mp="2f9zo67wawd0e">
                    <figcaption className="font-display text-sm font-bold text-white" data-id="element-185" data-mp="2fb12cl8m5fmc">
                      {review.name}
                    </figcaption>
                    <p className="mt-1 flex items-start gap-1 text-xs leading-snug text-gray-500" data-id="element-186" data-mp="269b7f5fivyjt">
                      <MapPinIcon className="mt-px h-3.5 w-3.5 flex-none" data-id="element-187" data-mp="21aq7z883hiwf" />
                      <span data-id="element-188" data-mp="21ct66fjeiic8">{review.detail}</span>
                    </p>
                  </div>
                </div>
                <blockquote className="mt-5 text-sm leading-relaxed text-gray-300" data-id="element-189" data-mp="3vor4hmg69ttc">
                  “{review.quote}”
                </blockquote>
                <div className="mt-auto" data-id="element-190" data-mp="7236zv666dsa">
                  <GoldStars data-id="element-191" data-mp="c1pio06cnlyz" />
                </div>
              </figure>
            </Reveal>)}
        </div>
      </div>
    </section>;
}